module.exports = __webpack_public_path__ + "img/img-2.575e9d98.webp";